import { render } from "./PensamientoEditor.vue?vue&type=template&id=36ed2106&scoped=true"
import script from "./PensamientoEditor.vue?vue&type=script&lang=js"
export * from "./PensamientoEditor.vue?vue&type=script&lang=js"

import "./PensamientoEditor.vue?vue&type=style&index=0&id=36ed2106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ed2106"]])

export default __exports__